<template>
    <div class="content_main message" v-loading="loading">
        <h2 class="title">待处理</h2>
        <h2 class="title">通知({{list.length}})</h2>
        <div>
            <!-- <el-row :grad="20" v-for="items in tableData" :key="items.data">
                <el-col :span="4">{{items.data}}</el-col>
                <el-col :span="12">
                    <p style="line-height:30px;border-bottom:1px solid #efefef;width:100%;" v-for="item in items.noticeList" :key="item.NoticeID">{{item.NoticeMsg}}</p>
                    
                </el-col>
            </el-row> -->
            <el-table
                :data="list"
                style="width: 100%">
                <el-table-column
                    prop="AddTime"
                    label="日期"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="NoticeMsg"
                    label="消息"
                    width="480">
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="操作">
                        <el-button type="text" @click="deleteNotice(list.NoticeID)"><i class="el-icon-delete"></i></el-button>
                        <el-button type="text" @click="islookNotice(list.NoticeID)"><i class="el-icon-view"></i></el-button>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            // tableData: [],
            loading: false,
            list: []
        }
    },
    methods:{
        getNoticeList(){
            this.loading = true;
            var params = {
                Action: 'GetNoticeGroupByDate'
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.loading = false;
                // this.tableData = data;
                _.each(data, item => {
                    
                    // let date = item.date;
                    _.each(item.noticeList, item => {
                        this.list.push(item);
                        // item['date'] = date
                    });
                    
                });
            }, err => {

            })
        },
        filterTag(){

        },
        deleteNotice(id){
            var params = {
                Action: 'DeleteNotice',
                NoticeID: id
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                 this.getNoticeList();
            },err => {

            })
        },
        islookNotice(id){
            this.$get('/Handler/FYGL.ashx',{action:'LookNotice',NoticeID: id}, data => {

            },err => {

            })
        }
    },
    created(){
        this.getNoticeList()
    }
}
</script>

<style scoped>
.message{
    width: 80%;
    padding: 25px;
}
.message .title{
    font-size: 16px;

}
</style>



// WEBPACK FOOTER //
// src/pages/message/message.vue